import { Form, Checkbox } from 'antd';
import get from 'lodash/get';
import React, { Component } from 'react';
import ProgressButton from 'react-progress-button';
import { ml } from 'src/_shared/services/utils.js';
import { JOB_STATUSES } from '../../../../_shared/constants';

class CloseJobForm extends Component {
	constructor(props) {
		super(props);
		this.state = {
			buttonState: '',
			theme: JSON.parse(get(props, 'currentUser.company.theme', '{}')),
		};
		this.formRef = React.createRef();
	}

	handleSubmit = (e) => {
		e.preventDefault();
		const { job, referrals } = this.props;
		this.formRef.current
			.validateFields()
			.then((values) => {
				this.setState({ buttonState: 'loading' });
				if (values.updateOtherReferrals) {
					for (const referral of referrals) {
						this.props.onUpdateReferral({
							input: {
								id: referral.id,
								status: 'notHired',
							},
						});
					}
				}

				this.props.onUpdateJob({
					id: job.id,
					status: JOB_STATUSES.CLOSED,
					jobType: job.jobType,
				});
				setTimeout(() => {
					this.setState({ buttonState: 'success' });
					this.props.onCancel();
				}, 2000);
			})
			.catch((error) => {
				this.setState({ buttonState: 'error' });
			});
	};

	render() {
		const { theme } = this.state;
		const { allMultiLingualData, currentUser } = this.props;
		return (
			<Form ref={this.formRef}>
				<div className="custom-gorm-group text-center">
					<Form.Item name="updateOtherReferrals" valuePropName="checked">
						<Checkbox>
							{ml(
								'Update referrals for this job as',
								currentUser,
								allMultiLingualData
							)}{' '}
							<span style={{ fontWeight: 700 }}>
								{ml('Not Hired', currentUser, allMultiLingualData)}
							</span>
						</Checkbox>
					</Form.Item>
				</div>

				<div className="modal-footer-btn">
					<ProgressButton
						durationSuccess={1}
						type="submit"
						state={this.state.buttonState}
						onClick={this.handleSubmit}
					>
						{ml('Close Job', currentUser, allMultiLingualData)}
					</ProgressButton>
				</div>
			</Form>
		);
	}
}

export default CloseJobForm;
